<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.ssoUnitId]"
		[controlName]="UnitCsvKeys.ssoUnitId"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.ssoUnitId]"
		[required]="form.get(UnitCsvKeys.ssoUnitId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.ssoCourseId]"
		[controlName]="UnitCsvKeys.ssoCourseId"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.ssoCourseId]"
		[required]="form.get(UnitCsvKeys.ssoCourseId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.defaultLangId]"
		[controlName]="UnitCsvKeys.defaultLangId"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.defaultLangId]"
		[required]="form.get(UnitCsvKeys.defaultLangId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.displayOrder]"
		[controlName]="UnitCsvKeys.displayOrder"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.displayOrder]"
		[required]="form.get(UnitCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.enName]"
		[controlName]="UnitCsvKeys.enName"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.enName]"
		[required]="form.get(UnitCsvKeys.enName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.enImageUri]"
		[controlName]="UnitCsvKeys.enImageUri"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.enImageUri]"
		[required]="form.get(UnitCsvKeys.enImageUri)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.enDescriptionShort]"
		[controlName]="UnitCsvKeys.enDescriptionShort"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.enDescriptionShort]"
		[required]="form.get(UnitCsvKeys.enDescriptionShort)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.enDescriptionHtml]"
		[controlName]="UnitCsvKeys.enDescriptionHtml"
		[placeholder]="UNIT_CSV_LABELS[UnitCsvKeys.enDescriptionHtml]"
		[required]="form.get(UnitCsvKeys.enDescriptionHtml)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="UNIT_CSV_LABELS[UnitCsvKeys.active]"
		[controlName]="UnitCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
